const useInputWithTextArea = ({ onChangeInput, onChangeTextarea, useHtmlInTextArea }) => {
  const handleChangeInput = e => {
    onChangeInput(e.target.value)
  }

  const handleChangeTextarea = value => {
    onChangeTextarea(value[useHtmlInTextArea ? 'html' : 'text'])
  }

  return {
    handleChangeInput,
    handleChangeTextarea,
  }
}

export default useInputWithTextArea
